import { requestFetch } from "@/js/helpers";
import { displayResult, displayError, setLoadingState } from "./_display.js";

/**
 * 戸建価格計算APIを呼び出す
 * @param {Object} data リクエストデータ
 * @param {HTMLElement} resultElement 結果表示要素
 */
export const calculateHousePrice = async (data, resultElement) => {
    try {
        setLoadingState(true, resultElement);
        const response = await requestFetch("/api/price/house", "POST", data);

        if (response.ok && response.data.success) {
            displayResult(response.data.data.total_price, resultElement);
        } else {
            displayError(resultElement);
            const errorMessage =
                response.data?.message || "価格計算に失敗しました。";
            alert(errorMessage);
            console.error("APIエラー:", response.data);
        }
    } catch (error) {
        displayError(resultElement);
        alert(
            "価格計算中にエラーが発生しました。しばらく時間をおいて再度お試しください。"
        );
        console.error("API呼び出しエラー:", error);
    } finally {
        setLoadingState(false, resultElement);
    }
};

/**
 * 土地価格計算APIを呼び出す
 * @param {Object} data リクエストデータ
 * @param {HTMLElement} resultElement 結果表示要素
 */
export const calculateLandPrice = async (data, resultElement) => {
    try {
        setLoadingState(true, resultElement);
        const response = await requestFetch("/api/price/land", "POST", data);

        if (response.ok && response.data.success) {
            displayResult(response.data.data.price, resultElement);
        } else {
            displayError(resultElement);
            const errorMessage =
                response.data?.message || "価格計算に失敗しました。";
            alert(errorMessage);
            console.error("APIエラー:", response.data);
        }
    } catch (error) {
        displayError(resultElement);
        alert(
            "価格計算中にエラーが発生しました。しばらく時間をおいて再度お試しください。"
        );
        console.error("API呼び出しエラー:", error);
    } finally {
        setLoadingState(false, resultElement);
    }
};
